import { defineTaggedUnion } from "foldkit/schema";

import * as admin from "./admin/message";
import * as adminModel from "./admin/model";
import { FetchUsers, page as adminPage } from "./admin/update";
import { view as adminView } from "./admin/view";
import * as agentsStub from "./agents/message";
import * as agentsStubModel from "./agents/model";
import { page as agentsStubPage } from "./agents/update";
import { view as agentsStubView } from "./agents/view";
import * as ai from "./ai/message";
import * as aiModel from "./ai/model";
import { page as aiPage } from "./ai/update";
import { view as aiView } from "./ai/view";
import * as attributeSchema from "./attributeSchema/message";
import * as attributeSchemaModel from "./attributeSchema/model";
import {
	FetchSchema,
	page as attributeSchemaPage,
} from "./attributeSchema/update";
import { view as attributeSchemaView } from "./attributeSchema/view";
import * as auditLog from "./auditLog/message";
import * as auditLogModel from "./auditLog/model";
import { FetchEvents, page as auditLogPage } from "./auditLog/update";
import { view as auditLogView } from "./auditLog/view";
import * as capture from "./capture/message";
import * as captureModel from "./capture/model";
import { ReadPayload, page as capturePage } from "./capture/update";
import { view as captureView } from "./capture/view";
import * as chat from "./chat/message";
import * as chatModel from "./chat/model";
import { page as chatPage } from "./chat/update";
import { view as chatView } from "./chat/view";
import * as creditUsage from "./creditUsage/message";
import * as creditUsageModel from "./creditUsage/model";
import {
	FetchSubscription,
	page as creditUsagePage,
} from "./creditUsage/update";
import { view as creditUsageView } from "./creditUsage/view";
import * as developer from "./developer/message";
import * as developerModel from "./developer/model";
import { ReadOptions, page as developerPage } from "./developer/update";
import { view as developerView } from "./developer/view";
import * as developers from "./developers/message";
import * as developersModel from "./developers/model";
import { ReadVariant, page as developersPage } from "./developers/update";
import { view as developersView } from "./developers/view";
import * as entry from "./entry/message";
import * as entryModel from "./entry/model";
import { FetchEntry, page as entryPage } from "./entry/update";
import { view as entryView } from "./entry/view";
import * as importPage from "./import/message";
import * as importPageModel from "./import/model";
import { page as importPagePage } from "./import/update";
import { view as importPageView } from "./import/view";
import * as integrations from "./integrations/message";
import * as integrationsModel from "./integrations/model";
import { ListKeys, page as integrationsPage } from "./integrations/update";
import { view as integrationsView } from "./integrations/view";
import * as keepInTouch from "./keepInTouch/message";
import * as keepInTouchModel from "./keepInTouch/model";
import { FetchWeek, page as keepInTouchPage } from "./keepInTouch/update";
import { view as keepInTouchView } from "./keepInTouch/view";
import * as knowledgeStub from "./knowledge/message";
import * as knowledgeStubModel from "./knowledge/model";
import { page as knowledgeStubPage } from "./knowledge/update";
import { view as knowledgeStubView } from "./knowledge/view";
import * as notFound from "./notFound/message";
import * as notFoundModel from "./notFound/model";
import { page as notFoundPage } from "./notFound/update";
import { view as notFoundView } from "./notFound/view";
import * as noteStub from "./note/message";
import * as noteStubModel from "./note/model";
import { page as noteStubPage } from "./note/update";
import { view as noteStubView } from "./note/view";
import * as rateCard from "./rateCard/message";
import * as rateCardModel from "./rateCard/model";
import { FetchHistory, page as rateCardPage } from "./rateCard/update";
import { view as rateCardView } from "./rateCard/view";
import * as record from "./record/message";
import * as recordModel from "./record/model";
import { FetchRecord, page as recordPage } from "./record/update";
import { view as recordView } from "./record/view";
import * as searched from "./searched/message";
import * as searchedModel from "./searched/model";
import { Search, page as searchedPage } from "./searched/update";
import { view as searchedView } from "./searched/view";
import * as settings from "./settings/message";
import * as settingsModel from "./settings/model";
import { page as settingsPage } from "./settings/update";
import { view as settingsView } from "./settings/view";
import * as tags from "./tags/message";
import * as tagsModel from "./tags/model";
import { FetchTags, page as tagsPage } from "./tags/update";
import { view as tagsView } from "./tags/view";
import * as taskStub from "./task/message";
import * as taskStubModel from "./task/model";
import { page as taskStubPage } from "./task/update";
import { view as taskStubView } from "./task/view";
import * as tasksStub from "./tasks/message";
import * as tasksStubModel from "./tasks/model";
import { page as tasksStubPage } from "./tasks/update";
import { view as tasksStubView } from "./tasks/view";

/**
 * Page registry keyed by route tag (KTD2). `Home` and `Records` share v1's
 * `Searched` page; every other tag is its own page.
 */
const searchedEntry = {
	Model: searchedModel.Model,
	Message: searched.Message,
	Load: Search,
	view: searchedView,
	...searchedPage,
};

export const pages = {
	Home: searchedEntry,
	Records: searchedEntry,
	Record: {
		Model: recordModel.Model,
		Message: record.Message,
		Load: FetchRecord,
		view: recordView,
		...recordPage,
	},
	Entry: {
		Model: entryModel.Model,
		Message: entry.Message,
		Load: FetchEntry,
		view: entryView,
		...entryPage,
	},
	Settings: {
		Model: settingsModel.Model,
		Message: settings.Message,
		OutMessage: settings.OutMessage,
		view: settingsView,
		...settingsPage,
	},
	Credits: {
		Model: creditUsageModel.Model,
		Message: creditUsage.Message,
		Load: FetchSubscription,
		view: creditUsageView,
		...creditUsagePage,
	},
	Rates: {
		Model: rateCardModel.Model,
		Message: rateCard.Message,
		Load: FetchHistory,
		view: rateCardView,
		...rateCardPage,
	},
	Developer: {
		Model: developerModel.Model,
		Message: developer.Message,
		OutMessage: developer.OutMessage,
		Load: ReadOptions,
		view: developerView,
		...developerPage,
	},
	Developers: {
		Model: developersModel.Model,
		Message: developers.Message,
		Load: ReadVariant,
		view: developersView,
		...developersPage,
	},
	Admin: {
		Model: adminModel.Model,
		Message: admin.Message,
		Load: FetchUsers,
		view: adminView,
		...adminPage,
	},
	Audit: {
		Model: auditLogModel.Model,
		Message: auditLog.Message,
		Load: FetchEvents,
		view: auditLogView,
		...auditLogPage,
	},
	AI: {
		Model: aiModel.Model,
		Message: ai.Message,
		view: aiView,
		...aiPage,
	},
	Chat: {
		Model: chatModel.Model,
		Message: chat.Message,
		view: chatView,
		...chatPage,
	},
	Integrations: {
		Model: integrationsModel.Model,
		Message: integrations.Message,
		Load: ListKeys,
		view: integrationsView,
		...integrationsPage,
	},
	KeepInTouch: {
		Model: keepInTouchModel.Model,
		Message: keepInTouch.Message,
		Load: FetchWeek,
		view: keepInTouchView,
		...keepInTouchPage,
	},
	Tags: {
		Model: tagsModel.Model,
		Message: tags.Message,
		OutMessage: tags.OutMessage,
		Load: FetchTags,
		view: tagsView,
		...tagsPage,
	},
	Import: {
		Model: importPageModel.Model,
		Message: importPage.Message,
		view: importPageView,
		...importPagePage,
	},
	Capture: {
		Model: captureModel.Model,
		Message: capture.Message,
		Load: ReadPayload,
		view: captureView,
		...capturePage,
	},
	AttributeSchema: {
		Model: attributeSchemaModel.Model,
		Message: attributeSchema.Message,
		Load: FetchSchema,
		view: attributeSchemaView,
		...attributeSchemaPage,
	},
	Tasks: {
		Model: tasksStubModel.Model,
		Message: tasksStub.Message,
		view: tasksStubView,
		...tasksStubPage,
	},
	Task: {
		Model: taskStubModel.Model,
		Message: taskStub.Message,
		view: taskStubView,
		...taskStubPage,
	},
	Knowledge: {
		Model: knowledgeStubModel.Model,
		Message: knowledgeStub.Message,
		view: knowledgeStubView,
		...knowledgeStubPage,
	},
	Note: {
		Model: noteStubModel.Model,
		Message: noteStub.Message,
		view: noteStubView,
		...noteStubPage,
	},
	Agents: {
		Model: agentsStubModel.Model,
		Message: agentsStub.Message,
		view: agentsStubView,
		...agentsStubPage,
	},
	NotFound: {
		Model: notFoundModel.Model,
		Message: notFound.Message,
		view: notFoundView,
		...notFoundPage,
	},
};
export type Pages = typeof pages;
export type PageTag = keyof Pages;

/** The active page slice on the root Model: `{ _tag: <PageTag>, model }`. */
export const PageModel = defineTaggedUnion({
	Home: { model: pages.Home.Model },
	Records: { model: pages.Records.Model },
	Record: { model: pages.Record.Model },
	Entry: { model: pages.Entry.Model },
	Settings: { model: pages.Settings.Model },
	Credits: { model: pages.Credits.Model },
	Rates: { model: pages.Rates.Model },
	Developer: { model: pages.Developer.Model },
	Developers: { model: pages.Developers.Model },
	Admin: { model: pages.Admin.Model },
	Audit: { model: pages.Audit.Model },
	AI: { model: pages.AI.Model },
	Chat: { model: pages.Chat.Model },
	Integrations: { model: pages.Integrations.Model },
	KeepInTouch: { model: pages.KeepInTouch.Model },
	Tags: { model: pages.Tags.Model },
	Capture: { model: pages.Capture.Model },
	AttributeSchema: { model: pages.AttributeSchema.Model },
	Import: { model: pages.Import.Model },
	Tasks: { model: pages.Tasks.Model },
	Task: { model: pages.Task.Model },
	Knowledge: { model: pages.Knowledge.Model },
	Note: { model: pages.Note.Model },
	Agents: { model: pages.Agents.Model },
	NotFound: { model: pages.NotFound.Model },
});
export type PageModel = typeof PageModel.Type;

/** A page Message lifted to the root: `{ _tag: <PageTag>, message }`. */
export const PageMessage = defineTaggedUnion({
	Home: { message: pages.Home.Message },
	Records: { message: pages.Records.Message },
	Record: { message: pages.Record.Message },
	Entry: { message: pages.Entry.Message },
	Settings: { message: pages.Settings.Message },
	Credits: { message: pages.Credits.Message },
	Rates: { message: pages.Rates.Message },
	Developer: { message: pages.Developer.Message },
	Developers: { message: pages.Developers.Message },
	Admin: { message: pages.Admin.Message },
	Audit: { message: pages.Audit.Message },
	AI: { message: pages.AI.Message },
	Chat: { message: pages.Chat.Message },
	Integrations: { message: pages.Integrations.Message },
	KeepInTouch: { message: pages.KeepInTouch.Message },
	Tags: { message: pages.Tags.Message },
	Capture: { message: pages.Capture.Message },
	AttributeSchema: { message: pages.AttributeSchema.Message },
	Import: { message: pages.Import.Message },
	Tasks: { message: pages.Tasks.Message },
	Task: { message: pages.Task.Message },
	Knowledge: { message: pages.Knowledge.Message },
	Note: { message: pages.Note.Message },
	Agents: { message: pages.Agents.Message },
	NotFound: { message: pages.NotFound.Message },
});
export type PageMessage = typeof PageMessage.Type;
